import { render, staticRenderFns } from "./contactModule.vue?vue&type=template&id=02568f7c"
import script from "./contactModule.vue?vue&type=script&lang=js"
export * from "./contactModule.vue?vue&type=script&lang=js"
import style0 from "./contactModule.vue?vue&type=style&index=0&id=02568f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports